import { IGoogleMapsResponse } from '../IDataMappings';

const googleApiMapper = {
  response(data: google.maps.GeocoderResult[]): IGoogleMapsResponse {

    const location = {
      latitude: data[0]?.geometry.location?.lat(),
      longitude: data[0]?.geometry.location?.lng(),
    };

    return { location };
  },
};

export default googleApiMapper;
